import { Component } from '@angular/core';
import { LogoComponent } from '../../components/logo/logo.component';
import { CookiePreferencesModalComponent } from '../../components/cookie-preferences-modal/cookie-preferences-modal.component';

@Component({
  standalone: true,
  selector: 'app-footer',
  imports: [LogoComponent, CookiePreferencesModalComponent],
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent {
  showCookiePreferences = false;

  openCookiePreferences(): void {
    this.showCookiePreferences = true;
  }

  closeCookiePreferences(): void {
    this.showCookiePreferences = false;
  }
}